module.exports = __webpack_public_path__ + "img/H000040_paperplane.5631dfad.png";